import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOperaComponent } from './simple-icons-opera.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOperaComponent ],
    exports:      [ SimpleIconsOperaComponent ],
    bootstrap:    []
})
export class SimpleIconsOperaModule {}
